import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class GetReportingPeriodApplicantsInteractor {
  private applicantService: IApplicantService;

  constructor(applicantService) {
    this.applicantService = applicantService;
  }

  async execute(reportingPeriodId: number, languageCode: number) {
    return this.applicantService.getReportingPeriodApplicants(
      reportingPeriodId,
      languageCode
    );
  }
}
